import PropTypes from 'prop-types'

import LightboxButton from '../LightboxButton'

import s from './Covers.module.css'

function Covers({
  images = [],
  lightboxImageIds = [],
  addToLightbox = () => {},
}) {
  if (images?.length < 1) return null

  const rows = images
    .map((e, i) => (i % 3 === 0 ? images.slice(i, i + 3) : null))
    .filter((i) => i)

  return rows.map((row, rowIndex) => (
    <div key={`${row[0].url}_${rowIndex}`} className={s.row}>
      {row.map((image) => (
        <div key={image.url} className={s.imageWrapper}>
          <div className={s.imageBackground}>
            <img
              key={image.url}
              src={image.url}
              className={s.image}
              loading="lazy"
            />
          </div>
          {lightboxImageIds && (
            <LightboxButton
              image={image}
              disabled={lightboxImageIds.includes(image.id)}
              onClick={addToLightbox}
            />
          )}
        </div>
      ))}
    </div>
  ))
}

Covers.propTypes = {
  images: PropTypes.array,
  lightboxImageIds: PropTypes.array,
  addToLightbox: PropTypes.func,
}

export default Covers
